import React, { useEffect, useState } from "react";
import "./styles.scss";
import {
  Button,
  FormCheck,
  InputBox,
  KeywordCheckBox,
  RadioButton,
} from "../../../../components";
import { CheckValidity } from "../../../../utils/formValidity";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import { useSelector } from "react-redux";
import htmlToDraft from "html-to-draftjs";
import { getNewsKeywords } from "../../../news/service/news.service";

const Sinhala = ({ onChange, finish }) => {
  const [formData, setFormData] = useState({
    titleSI: {
      key: "titleSI",
      label: "Title (SI)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    keyWord: {
      key: "keyWord",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    descriptionSI: {
      key: "descriptionSI",
      label: "Description (SI)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const { selectNews, isOpenAddUpdateNewsModal, isOpenNewsViewModal } =
    useSelector(({ newsReducer }) => newsReducer);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const [selectKeyword, setSelectKeyword] = useState("");
  const [suggestions, setSuggestions] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    const updateNewsForm = {
      ...formData,
      descriptionSI: {
        ...formData.descriptionSI,
        value: draftToHtml(convertToRaw(editorState.getCurrentContent())),
      },
    };
    setFormData(updateNewsForm);
  };

  const handleChange = async (event, inputIdentity) => {
    const updateNewsForm = {
      ...formData,
    };

    updateNewsForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewsForm[inputIdentity].value,
      updateNewsForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewsForm[inputIdentity].isValid = validityRes.isValid;
      updateNewsForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewsForm[inputIdentity].value = event;
      updateNewsForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewsForm) {
        formIsValid = updateNewsForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewsForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setEditorState(EditorState.createEmpty());
    setFormData(updateNewsForm);
  };

  useEffect(() => {
    onChange(formData);
  }, [formData]);

  useEffect(() => {
    if (finish) {
      clearAll();
    }
  }, [finish]);

  useEffect(() => {
    if (
      selectNews?.news_id &&
      !isOpenAddUpdateNewsModal &&
      !isOpenNewsViewModal
    ) {
      let updateFormData = { ...formData };
      updateFormData.titleSI.value = selectNews?.title["si"];

      const description = htmlToDraft(selectNews?.content["si"]);
      setEditorState(EditorState.createEmpty());

      if (description && description.contentBlocks) {
        const contentState = ContentState.createFromBlockArray(
          description.contentBlocks
        );
        setEditorState(EditorState.createWithContent(contentState));
      }

      setFormData(updateFormData);
    } else {
      clearAll();
    }
  }, [selectNews]);

  const generateKeywords = async () => {
    setIsLoading(true);
    const updateNewsForm = { ...formData };
    try {
      const body = {
        title: updateNewsForm.titleEN.value,
      };
      const response = await getNewsKeywords(body, "si");
      console.log({ response });
      if (response?.data?.status) {
        setSuggestions(response?.data?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const updateNewsForm = { ...formData };

  return (
    <>
      <div className={"sinhala-language-wrapper"}>
        <InputBox
          data={updateNewsForm.titleSI}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(e.target.value, updateNewsForm.titleSI.key);
          }}
        />

        {/* <TextArea
          data={updateNewsForm.descriptionSI}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(
              e.target.value,
              updateNewsForm.descriptionSI.key
            );
          }}
        /> */}
        {/* <Button
          data={{
            btnName: "GENERATE KEYWORD",
            buttonType: "black-border mr-2 mb-3",
            buttonSize: "lg",
            isLoading: "",
          }}
          onClick={async (e) => {
            e.preventDefault();
          }}
        /> */}

        <div className="suggestions_key">
          <div className="sk_title">Sinhala Keyword Suggestions</div>

          {Array.isArray(suggestions) && suggestions.length > 0
            ? suggestions.map((item) => (
                <KeywordCheckBox
                  data={{ keyword: item, isSelect: selectKeyword === item }}
                  onClick={() => {
                    let updatedForm = { ...formData };
                    updatedForm.keyWord.value = item?.replace(/ /g, "-");
                    setSelectKeyword(item);
                  }}
                />
              ))
            : ""}
        </div>

        <InputBox
          data={updateNewsForm.keyWord}
          onChange={async (e) => {
            e.preventDefault();
            await handleChange(e.target.value, updateNewsForm.keyWord.key);
          }}
        />
        {updateNewsForm.keyWord.value && (
          <div className="news-url">
            {"https://sinhala.hopeofanewera.org/" +
              updateNewsForm.keyWord.value}
          </div>
        )}
        <label className={"txt-label"}>
          Description <b>*</b>
        </label>
        <div className={"rich-text-editor-wrapper"}>
          <Editor
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            onEditorStateChange={onEditorStateChange}
            toolbar={{
              fontFamily: {
                options: ["gothambook"],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
              },
              fontSize: {
                icon: undefined,
                options: [11, 12, 13, 14, 18, 24],
                className: undefined,
                component: undefined,
                dropdownClassName: undefined,
              },
            }}
          />
        </div>
      </div>
    </>
  );
};
export default Sinhala;
